import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../utils/contants";

const getBackgroundColor = (variant) => {
  if (variant === "purple") return COLOUR_CONSTANT.theme.purple.light;
  if (variant === "dark") return "#301D35";
  if (variant === "light") return "#fff";
};

const getColor = (variant) => {
  if (variant === "purple") return COLOUR_CONSTANT.theme.background.dark;
  if (variant === "dark") return "#fff";
  if (variant === "light") return "#301D35";
};

export const AccordianStyled = styled.div`
  .expanded {
    .MuiAccordionSummary-root {
      align-items: start;
    }
    .MuiAccordionSummary-expandIconWrapper {
      position: relative;
      top: 10px;
    }
  }
  .MuiAccordionSummary-content {
    margin: 0 !important;
  }
  .MuiAccordionSummary-root {
    flex-direction: ${(props) =>
      props.arrowPosition === "right" ? "auto" : "row-reverse"};
    border-radius: 5px;
    gap: 16px !important;
    background-color: ${(props) =>
      getBackgroundColor(props?.variant)} !important;
    color: ${(props) => getColor(props.variant)};
    border-bottom-left-radius: ${({ isExpandable }) =>
      isExpandable ? "0" : "auto"} !important;
    border-bottom-right-radius: ${({ isExpandable }) =>
      isExpandable ? "0" : "auto"} !important;
    padding-left: 0;
    display: flex;
    align-items: center;

    .MuiAccordionSummary-expandIconWrapper {
      transform: ${(props) =>
        props.arrowPosition === "right" ? " rotate(90deg);" : "auto"};
      svg {
        color: ${(props) => (props.variant === "dark" ? "white" : "#301D35")};
      }
    }
    .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
      transform: rotate(-90deg);
    }
  }
  .MuiAccordion-root {
    box-shadow: none;
    border-bottom: 1px solid #dedafb;
  }

  .MuiAccordionDetails-root {
    padding: 0;
    border: 1px solid #dedafb;
  }

  .heading {
    width: 100%;
    display: flex;
    gap: 16px;
    padding: 8px 0;
    align-items: center;
  }

  .drag {
    cursor: grab;
    background-color: #dedafb;
    align-content: center;
    border-top-left-radius: 5px !important;
    border-bottom-left-radius: ${({ isExpandable }) =>
      isExpandable ? "0" : "5px"} !important;
  }
`;
